import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Label } from '../../../components/Label';
import { FormItem } from '../../../components/FormItem';
import type { InputDefaultProps } from '../types';
import { CustomInputNumber } from './styles';

export function CaptureInterval({ fieldName }: Readonly<InputDefaultProps>): JSX.Element {
	const title = `${I18n.get('Capture interval')} (${I18n.get('in seconds')})`;

	return (
		<Col span={24}>
			<Row gutter={[0, 10]}>
				<Col span={24}>
					<Label isRequired tooltip="Set the time interval, in seconds, for capturing video frames.">
						{title}
					</Label>
				</Col>
				<Col span={24}>
					<FormItem
						name={[fieldName, 'capture_interval_seconds']}
						rules={[{ required: true, message: I18n.get('Enter the capture interval') }]}
					>
						<CustomInputNumber min={1} size="large" placeholder="1" />
					</FormItem>
				</Col>
			</Row>
		</Col>
	);
}
